// recheckDrmCapability.js
'use strict';
import { REMOVE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Recheck drm capability
 * @kind action
 * @return {Promise} Action promise.
 */
const recheckDrmCapability = () => async dispatch => {
  dispatch({
    type: REMOVE_OPERATION_DATA,
    payload: {
      selectPath: ['drm'],
    },
  });
  const checkDrmCapability = (await import('../action/checkDrmCapability.js'))
    .default;
  return dispatch(
    checkDrmCapability({
      isEarlyLeave: false,
      isManualCheck: true,
    })
  );
};

export default recheckDrmCapability;
